function getCookieByCart(key) {
  var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? keyValue[2] : null;
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (event) => {
        event.preventDefault(),
          (
            this.closest("cart-items") || this.closest("cart-drawer-items")
          ).updateQuantity(
            this.dataset.index,
            0,
            null,
            this.dataset.quantityVariantId
          );
      });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    this.getImagePreviewimgTag();
    this.getImagePreview();

    //this.loadAllThumbnailImage();
  }

  handleOpenModalClick = (src) => {
    const imgEl = document.querySelector(
      ".cus-preview-modal-wrapper #cus-preview-img"
    );
    imgEl.src = src;
    const modalItem = document.querySelector(".cus__modal__preview");
    modalItem.classList.toggle("open");
  };

  handleCloseModal = () => {
    const modalItem = document.querySelector(".cus__modal__preview");
    modalItem.classList.toggle("open");
  };

getImagePreview() {
  const allCartItems = document.querySelectorAll(".cart-item");

  allCartItems.forEach((cartItem) => {
    const imgTag = cartItem.querySelector('.cart-item__media img');
    
    if (!imgTag) return; // Skip if no image found
    
    const src = imgTag.getAttribute('preview-src') || imgTag.src;
    
    // Get both the image container and preview button
    const imageElement = cartItem.querySelector('.cart-item__media');
    const previewElement = cartItem.querySelector('.cart-item__media_preview');
    
    // Add event listener to image
    if (imageElement && !imageElement.hasOwnProperty("isEvent")) {
      imageElement.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleOpenModalClick(src);
      });
      imageElement.isEvent = true;
    }
    
    // Add event listener to preview button
    if (previewElement && !previewElement.hasOwnProperty("isEvent")) {
      previewElement.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleOpenModalClick(src);
      });
      previewElement.isEvent = true;
    }
  });
}

  handleCloseGS() {
    document.querySelector(".cus-close").addEventListener("click", (e) => {
      e.preventDefault();
      this.handleCloseModal();
    });
    document
      .querySelector(".cus__modal__preview")
      .addEventListener("click", (e) => {
        e.preventDefault();
        this.handleCloseModal();
      });
  }

  getImagePreviewimgTag() {
    function getImageFromLocalStorage(timestamp) {
      const keySavePreviewImage = "gs-preview-" + timestamp;

      const storedData = JSON.parse(localStorage.getItem(keySavePreviewImage));

      if (storedData && storedData.imagepreviewgs) {
        return storedData.imagepreviewgs;
      } else {
        return null;
      }
    }

    $(".cart-item").each(function () {
      var timestamp = $(this).data("timestamp");

      var retrievedImage = getImageFromLocalStorage(timestamp);

      if (retrievedImage) {
        $(this).find(".cart-item__image").attr("src", retrievedImage);
      }
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          this.getImagePreview();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=gs-new-cart`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents-right",
      },
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart__heading__gs",
        section: "cart-heading-gs",
        selector: ".shopify-section",
      },
    ];
  }

  loadAllThumbnailImage() {
    var allCartItemImg = document.querySelectorAll(
      ".cart-item__media .cart-item__image-container img"
    );

    allCartItemImg.forEach((element) => {
      element.addEventListener("load", function () {
        console.log("that preview was loaded");
      });

      element.addEventListener("error", function () {
        element.onerror = null;
        const parrent = element.closest(".cart-item__media");
        const key = parrent.getAttribute("data-key");
        const cartItem = tfxCart.items.find((item) => item.key === key);
        var properties = cartItem.properties;
        var thumbImageId = properties.find(
          (p) => p[0] == "_customily-thumb-id"
        );
        var thumbImage = properties.find((p) => p[0] == "_customily-thumb");
        if (thumbImageId && thumbImageId[1]) {
          var id = thumbImageId[1].split("_thumb-id-")[1];
          var data = localStorage.getItem("customily-shopify-thumbs-" + id);
          if (data && Date.now() - data.timestamp < 2592e6) {
            var base64 = JSON.parse(data).image;
            setTimeout(function () {
              element.src = base64;
            }, 1000);
          }
        } else if (thumbImage && thumbImage[1]) {
          element.src = thumbImage[1];
        }
      });
    });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    // Capture the timestamp before the item might be removed
    const lineItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    const timestamp = lineItem ? lineItem.getAttribute("data-timestamp") : null;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartPageItems = document.querySelector("cart-items");
        const cartDrawerItems = document.querySelector("cart-drawer-items");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
        if (cartPageItems)
          cartPageItems.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
        if (cartDrawerItems)
          cartDrawerItems.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        // Check if the item is being removed from the cart
        if (quantity === 0 && timestamp) {
          const storageKey = `gs-preview-${timestamp}`;

          // Remove the local storage item with the corresponding timestamp
          if (localStorage.getItem(storageKey)) {
            localStorage.removeItem(storageKey);
          } else {
          }
        }

        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this.getImagePreview();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML; // check gs .innerhtml
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );
    const cartDrawerItemLoadingSpinner = document.querySelectorAll(
      `.totals .loading-overlay`
    );
    const cartDrawerTotalsLoadingSpinner =
      document.querySelectorAll(`.totals p`);

    [
      ...cartItemElements,
      ...cartDrawerItemElements,
      ...cartDrawerItemLoadingSpinner,
    ].forEach((overlay) => overlay.classList.remove("hidden"));
    cartDrawerTotalsLoadingSpinner.forEach((overlay) =>
      overlay.classList.add("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
